// extracted by mini-css-extract-plugin
export default {"container":"Comment_container__Q0sRl","author":"Comment_author__XCflk","authorIcon":"Comment_authorIcon__-1I7o","date":"Comment_date__iGQsk","content":"Comment_content__Hf35P"};